import { render, staticRenderFns } from "./ElButtonPerziureti.vue?vue&type=template&id=ac3e5476&scoped=true&"
import script from "./ElButtonPerziureti.vue?vue&type=script&lang=js&"
export * from "./ElButtonPerziureti.vue?vue&type=script&lang=js&"
import style0 from "./ElButtonPerziureti.vue?vue&type=style&index=0&id=ac3e5476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3e5476",
  null
  
)

export default component.exports